import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "docs-listing docs-listing--podcasts" }

import { onBeforeMount, Raw, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import Layout from '@/app/components/Layout.vue'
import HeaderRoot from '@/app/components/header/Root.vue'
import LatestEpisodesBlock from '@/app/components/listing/LatestEpisodesBlock.vue'
import ListDocs from '@/app/components/listing/ListDocs.vue'
import EarlyAccessBannerPodcast from '@/app/components/doc/EarlyAccessBannerPodcast.vue'
import LoadingError from '@/components/ui/LoadingError.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'

import { PodcastsView } from '@/models/docs.list.podcasts'
import { createFollowedPodcastEpisodesView, ListView } from '@/models/docs.list'


export default /*@__PURE__*/_defineComponent({
  __name: 'Podcasts',
  setup(__props) {

const wait = useWait()

const podcastsView = ref<Raw<ListView> | null>(null)
const followedEpisodesView = ref<Raw<ListView> | null>(null)

onBeforeMount(async () => {
  wait.start('Loading Podcasts')

  try {
    await Promise.all([loadPodcasts(), loadFollowedEpisodes()])
    wait.end('Loading Podcasts')
  } catch (error) {
    wait.start('Error Loading Podcasts')
    Sentry.captureException(error)
  }
})

async function loadPodcasts(): Promise<void> {
  const response = await backend.getPodcasts()
  const podcasts = new PodcastsView(response)
  podcastsView.value = new ListView('All Podcasts', podcasts)
}

async function loadFollowedEpisodes(): Promise<void> {
  // This function has a try/catch block so that it doesn't
  // prevent the page from loading if there's an error
  try {
    followedEpisodesView.value = await createFollowedPodcastEpisodesView()
  } catch (error: any) {
    Sentry.captureException(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createBlock(Layout, { class: "layout--basic" }, {
    default: _withCtx(() => [
      _createVNode(HeaderRoot, { title: "Podcasts" }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(EarlyAccessBannerPodcast),
        _createVNode(_component_v_wait, { for: "Error Loading Podcasts" }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingError)
          ]),
          _: 1
        }),
        _createVNode(_component_v_wait, {
          class: "layout__wrapper-inner container",
          for: "Loading Podcasts"
        }, {
          waiting: _withCtx(() => [
            _createVNode(LoadingSpinner)
          ]),
          default: _withCtx(() => [
            (followedEpisodesView.value)
              ? (_openBlock(), _createBlock(LatestEpisodesBlock, {
                  key: 0,
                  view: followedEpisodesView.value
                }, null, 8, ["view"]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_2, [
              (podcastsView.value)
                ? (_openBlock(), _createBlock(ListDocs, {
                    key: 0,
                    view: podcastsView.value
                  }, null, 8, ["view"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})